import { RuleProps } from 'types/application';

export const OTHER_DETAILS = 'other-details';
export const VENDOR_INFORMATION = 'vendor-information';
export const VENDOR_ADDRESS = 'vendor-address';
export const STATION_TYPE = 'station-type';
export const STATION_DETAILS = 'station-details';
export const ANTENNA_INFORMATION = 'antenna-information';
export const ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION = 'antenna-displacement-from-station-location';
export const FILTER_INFORMATION = 'filter-information';
export const MOBILE_FREQUENCY_INFO = 'mobile-frequency-information';
export const LAND_FIXED_RADIO_EQUIPMENT_INFO = 'land-fixed-radio-equipment-information';
export const LAND_FIXED_FREQUENCY_INFO = 'frequency-and-emission-class-information';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';

export const SPS_APPLICATION = [
    {
        sectionID: OTHER_DETAILS,
        sectionName: '',
        fieldList: [
            {
                id: 'proposed-used-of-system',
                label: 'Proposed use of System',
                type: 'dropdown',
                apiID: 'CommonData',
                category: 'LICCommonData',
                span: 12
            }
        ]
    },
    {
        sectionID: STATION_TYPE,
        sectionName: '',
        fieldList: [
            {
                id: 'station-type',
                label: 'Station Type',
                type: 'text'
            }
        ],
        rule: {
            baseIds: [`${OTHER_DETAILS}-proposed-used-of-system`],
            hidden: ({ baseValues }: RuleProps) => {
                const result = Boolean(baseValues && baseValues[`${OTHER_DETAILS}-proposed-used-of-system`] !== 'PUSP03');
                return result;
            }
        }
    },
    {
        sectionID: VENDOR_INFORMATION,
        sectionName: 'Vendor Information',
        fieldList: [
            {
                id: 'company-name',
                label: 'Company Name',
                type: 'text'
            },
            {
                id: 'vendor-licence-number',
                label: 'Vendor Licence Number',
                type: 'text'
            },
            {
                id: 'contact-person',
                label: 'Contact Person Name',
                type: 'text'
            },
            {
                id: 'contact-number',
                label: 'Contact Number (Optional)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: VENDOR_ADDRESS,
        sectionName: 'Vendor Address',
        fieldList: [
            {
                id: 'address-type',
                label: 'Address Type',
                type: 'text',
                span: 12
            },
            {
                id: 'address-line-1',
                label: 'Address Line 1',
                type: 'text',
                rule: {
                    baseIds: [`${VENDOR_ADDRESS}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            (baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Local') ||
                                (baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Singapore')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'address-line-2',
                label: 'Address Line 2',
                type: 'text',
                rule: {
                    baseIds: [`${VENDOR_ADDRESS}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            (baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Local') ||
                                (baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Singapore')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'address-line-3',
                label: 'Address Line 3',
                type: 'text',
                rule: {
                    baseIds: [`${VENDOR_ADDRESS}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            (baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Local') ||
                                (baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Singapore')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'address-line-4',
                label: 'Address Line 4',
                type: 'text',
                rule: {
                    baseIds: [`${VENDOR_ADDRESS}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            (baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Local') ||
                                (baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Singapore')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'address-line-5',
                label: 'Address Line 5',
                type: 'text',
                rule: {
                    baseIds: [`${VENDOR_ADDRESS}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            (baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Local') ||
                                (baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Singapore')
                        );
                        return result;
                    }
                },
                span: 12
            },
            {
                id: 'city',
                label: 'City',
                type: 'dropdown',
                apiID: 'Country',
                rule: {
                    baseIds: [`${VENDOR_ADDRESS}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            (baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Local') ||
                                (baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Singapore')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'state',
                label: 'State',
                type: 'text',
                rule: {
                    baseIds: [`${VENDOR_ADDRESS}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            (baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Local') ||
                                (baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Singapore')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'zip-code',
                label: 'Zip Code',
                type: 'text',
                rule: {
                    baseIds: [`${VENDOR_ADDRESS}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            (baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Local') ||
                                (baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Singapore')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'country',
                label: 'Country',
                type: 'dropdown',
                apiID: 'Country',
                rule: {
                    baseIds: [`${VENDOR_ADDRESS}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            (baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Local') ||
                                (baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Singapore')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'building-name',
                label: 'Building Name',
                type: 'text',
                rule: {
                    baseIds: [`${VENDOR_ADDRESS}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'postal-code',
                label: 'Postal Code',
                type: 'text',
                rule: {
                    baseIds: [`${VENDOR_ADDRESS}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text',
                rule: {
                    baseIds: [`${VENDOR_ADDRESS}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'block-house-no',
                label: 'Block/House No.',
                type: 'text',
                rule: {
                    baseIds: [`${VENDOR_ADDRESS}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'floor-level',
                label: 'Floor/Level',
                type: 'text',
                rule: {
                    baseIds: [`${VENDOR_ADDRESS}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'unit',
                label: 'Unit',
                type: 'text',
                rule: {
                    baseIds: [`${VENDOR_ADDRESS}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${VENDOR_ADDRESS}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            }
        ]
    },
    {
        sectionID: STATION_DETAILS,
        sectionName: '',
        fieldList: [
            {
                id: 'station-tabs',
                label: '',
                type: 'tab',
                span: 12,
                tabs: [
                    {
                        id: '1',
                        label: 'Fixed Station Details',
                        type: 'subTab',
                        subTabs: [
                            {
                                id: '1',
                                label: 'Station 1',
                                content: [
                                    {
                                        id: 'location-of-station',
                                        label: 'Location of Station',
                                        type: 'text'
                                    },
                                    {
                                        id: 'operating-address',
                                        label: 'Operating Address',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'building-name',
                                        label: 'Building Name',
                                        type: 'text'
                                    },
                                    {
                                        id: 'postal-code',
                                        label: 'Postal Code',
                                        type: 'text'
                                    },
                                    {
                                        id: 'street-name',
                                        label: 'Street Name',
                                        type: 'text'
                                    },
                                    {
                                        id: 'block-house-no',
                                        label: 'Block/House No.',
                                        type: 'text'
                                    },
                                    {
                                        id: 'floor-level',
                                        label: 'Floor/Level (Optional)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'unit',
                                        label: 'Unit (Optional)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'latitude',
                                        label: 'Latitude',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'latitude-degrees',
                                        label: 'Latitude Degrees',
                                        type: 'text'
                                    },
                                    {
                                        id: 'latitude-minutes',
                                        label: 'Latitude Minutes',
                                        type: 'text'
                                    },
                                    {
                                        id: 'latitude-seconds',
                                        label: 'Latitude Seconds',
                                        type: 'text'
                                    },
                                    {
                                        id: 'longitude',
                                        label: 'Longitude',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'longitude-degrees',
                                        label: 'Longitude Degrees',
                                        type: 'text'
                                    },
                                    {
                                        id: 'longitude-minutes',
                                        label: 'Longitude Minutes',
                                        type: 'text'
                                    },
                                    {
                                        id: 'longitude-seconds',
                                        label: 'Longitude Seconds',
                                        type: 'text'
                                    },
                                    {
                                        id: '',
                                        label: '',
                                        type: 'text'
                                    },
                                    {
                                        id: 'building-height-m',
                                        label: 'Building Height (m)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'antenna-structure-height-m',
                                        label: 'Antenna Structure Height (m)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'antenna-elevation-angle',
                                        label: 'Antenna Elevation Angle - with reference to horizontal plane (degree)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'transportable',
                                        label: 'Transportable?',
                                        type: 'text'
                                    },
                                    {
                                        id: 'radius-of-operation',
                                        label: 'Radius of Operation (km)',
                                        type: 'text'
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        id: '2',
                        label: 'Mobile Station Details',
                        type: 'subTab',
                        subTabs: [
                            {
                                id: '1',
                                label: 'Station 1',
                                content: [
                                    {
                                        id: 'station-name',
                                        label: 'Station Name',
                                        type: 'text'
                                    },
                                    {
                                        id: 'latitude',
                                        label: 'Latitude',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'latitude-degrees',
                                        label: 'Latitude Degrees',
                                        type: 'text'
                                    },
                                    {
                                        id: 'latitude-minutes',
                                        label: 'Latitude Minutes',
                                        type: 'text'
                                    },
                                    {
                                        id: 'latitude-seconds',
                                        label: 'Latitude Seconds',
                                        type: 'text'
                                    },
                                    {
                                        id: 'longitude',
                                        label: 'Longitude',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'longitude-degrees',
                                        label: 'Longitude Degrees',
                                        type: 'text'
                                    },
                                    {
                                        id: 'longitude-minutes',
                                        label: 'Longitude Minutes',
                                        type: 'text'
                                    },
                                    {
                                        id: 'longitude-seconds',
                                        label: 'Longitude Seconds',
                                        type: 'text'
                                    },
                                    {
                                        id: 'operating-address',
                                        label: 'Operating Address',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'building-name',
                                        label: 'Building Name',
                                        type: 'text'
                                    },
                                    {
                                        id: 'postal-code',
                                        label: 'Postal Code',
                                        type: 'text'
                                    },
                                    {
                                        id: 'street-name',
                                        label: 'Street Name',
                                        type: 'text'
                                    },
                                    {
                                        id: 'block-house-no',
                                        label: 'Block/House No.',
                                        type: 'text'
                                    },
                                    {
                                        id: 'floor-level',
                                        label: 'Floor/Level',
                                        type: 'text'
                                    },
                                    {
                                        id: 'unit',
                                        label: 'Unit',
                                        type: 'text'
                                    },
                                    {
                                        id: 'radio-equipment-information',
                                        label: 'Radio Equipment Information',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'manufacturer',
                                        label: 'Manufacturer',
                                        type: 'text'
                                    },
                                    {
                                        id: 'model',
                                        label: 'Model',
                                        type: 'text'
                                    },
                                    {
                                        id: 'output-power-w',
                                        label: 'Output Power (W)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'number-of-mobile-portables',
                                        label: 'Number of Mobile/Portable(s)',
                                        type: 'text'
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        sectionID: ANTENNA_INFORMATION,
        sectionName: 'Antenna Information',
        fieldList: [
            {
                id: 'antenna-manufacturer',
                label: 'Manufacturer',
                type: 'text'
            },
            {
                id: 'polarization',
                label: 'Polarization (Optional)',
                type: 'text'
            },
            {
                id: 'antenna-effective-height',
                label: 'Antenna Effective Height (m) (above ground level)',
                type: 'text'
            },
            {
                id: 'antenna-elevation-angle',
                label: 'Antenna Elevation Angle - with reference to horizontal plane (degree)',
                type: 'text'
            }
        ],
        rule: {
            baseIds: [`${STATION_TYPE}-station-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const result = Boolean(baseValues && baseValues[`${STATION_TYPE}-station-type`] === 'Mobile/Portable Station');
                return result;
            }
        }
    },
    {
        sectionID: ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION,
        sectionName: 'Antenna Displacement From Station Location',
        fieldList: [
            {
                id: 'north-latitude-displacement',
                label: 'North Latitude Displacement (Optional)',
                type: 'text'
            },
            {
                id: 'east-longitude-displacement',
                label: 'East Longitude Displacement (Optional)',
                type: 'text'
            },
            {
                id: 'gain-db',
                label: 'Gain (dB)',
                type: 'text'
            }
        ],
        rule: {
            baseIds: [`${STATION_TYPE}-station-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const result = Boolean(baseValues && baseValues[`${STATION_TYPE}-station-type`] === 'Mobile/Portable Station');
                return result;
            }
        }
    },
    {
        sectionID: LAND_FIXED_RADIO_EQUIPMENT_INFO,
        sectionName: 'Radio Equipment Information',
        fieldList: [
            {
                id: 'land-fixed-radio-equipment-information',
                label: '',
                type: 'tableAccordion',
                span: 12,
                subFields: [
                    {
                        id: 'land-fixed-radio-equipment-info-table',
                        label: '',
                        type: 'table',
                        subFields: [
                            {
                                id: 'no',
                                header: 'No.',
                                type: 'text'
                            },
                            {
                                id: 'manufacturer-transmitter',
                                header: 'Manufacturer (Transmitter)',
                                type: 'text'
                            },
                            {
                                id: 'manufacturer-receiver',
                                header: 'Manufacturer (Receiver)',
                                type: 'text'
                            },
                            {
                                id: 'model-transmitter',
                                header: 'Model (Transmitter)',
                                type: 'text'
                            },
                            {
                                id: 'model-receiver',
                                header: 'Model (Receiver)',
                                type: 'text'
                            },
                            {
                                id: 'output-power-transmitter',
                                header: 'Output Power (Transmitter)',
                                type: 'text'
                            }
                        ]
                    },
                    {
                        id: 'land-fixed-radio-equipment-info-accordion',
                        label: '',
                        type: 'accordion',
                        subFields: []
                    }
                ]
            }
        ],
        rule: {
            baseIds: [`${STATION_TYPE}-station-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const result = Boolean(baseValues && baseValues[`${STATION_TYPE}-station-type`] !== 'Land Fixed Station');
                return result;
            }
        }
    },
    {
        sectionID: MOBILE_FREQUENCY_INFO,
        sectionName: 'Mobile Station - Frequency Info',
        fieldList: [
            {
                id: 'mobile-frequency-information-list',
                label: '',
                type: 'tableAccordion',
                span: 12,
                subFields: [
                    {
                        id: 'mobile-frequency-info-table',
                        label: '',
                        type: 'table',
                        subFields: [
                            {
                                id: 'no',
                                header: 'No.',
                                type: 'text'
                            },
                            {
                                id: 'transmit-frequency-mhz-from',
                                header: 'Transmit Frequency (MHz) - From',
                                type: 'text'
                            },
                            {
                                id: 'transmit-frequency-mhz-to',
                                header: 'Transmit Frequency (MHz) - To',
                                type: 'text'
                            },
                            {
                                id: 'transmit-bandwidth-khz',
                                header: 'Transmit Bandwidth (KHz)',
                                type: 'text'
                            },
                            {
                                id: 'receive-frequency-mhz-from',
                                header: 'Receive Frequency (MHz) - From',
                                type: 'text'
                            },
                            {
                                id: 'receive-frequency-mhz-to',
                                header: 'Receive Frequency (MHz) - To',
                                type: 'text'
                            },
                            {
                                id: 'receive-bandwidth-khz',
                                header: 'Receive Bandwidth (KHz)',
                                type: 'text'
                            },
                            {
                                id: 'emission-class-transmit',
                                header: 'Emission Class (Transmit)',
                                type: 'text'
                            }
                        ]
                    },
                    {
                        id: 'mobile-frequency-info-accordion',
                        label: '',
                        type: 'accordion',
                        subFields: []
                    }
                ]
            }
        ],
        rule: {
            baseIds: [`${STATION_TYPE}-station-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const result = Boolean(baseValues && baseValues[`${STATION_TYPE}-station-type`] === 'Land Fixed Station');
                return result;
            }
        }
    },
    {
        sectionID: LAND_FIXED_FREQUENCY_INFO,
        sectionName: 'Frequency Info',
        fieldList: [
            {
                id: 'frequency-and-emission-class-information',
                label: '',
                type: 'tableAccordion',
                span: 12,
                subFields: [
                    {
                        id: 'frequency-and-emission-class-info-table',
                        label: '',
                        type: 'table',
                        subFields: [
                            {
                                id: 'no',
                                header: 'No.',
                                type: 'text'
                            },
                            {
                                id: 'start-time',
                                header: 'Start Time',
                                type: 'text'
                            },
                            {
                                id: 'stop-time',
                                header: 'Stop Time',
                                type: 'text'
                            },
                            {
                                id: 'desired-frequency-mhz-from-transmit',
                                header: 'Desired Frequency (MHz) - From (Transmit)',
                                type: 'text'
                            },
                            {
                                id: 'desired-frequency-mhz-to-transmit',
                                header: 'Desired Frequency (MHz) - To (Transmit)',
                                type: 'text'
                            },
                            {
                                id: 'desired-frequency-mhz-from-receive',
                                header: 'Desired Frequency (MHz) - From (Receive)',
                                type: 'text'
                            },
                            {
                                id: 'desired-frequency-mhz-to-receive',
                                header: 'Desired Frequency (MHz) - To (Receive)',
                                type: 'text'
                            },
                            {
                                id: 'feeder-line-type-transmit',
                                header: 'Feeder Line Type (Transmit)',
                                type: 'text'
                            },
                            {
                                id: 'feeder-line-type-receive',
                                header: 'Feeder Line Type (Receive)',
                                type: 'text'
                            },
                            {
                                id: 'feeder-line-length-m-transmit',
                                header: 'Feeder Line Length(M) (Transmit)',
                                type: 'text'
                            },
                            {
                                id: 'feeder-line-length-m-receive',
                                header: 'Feeder Line Length(M) (Receive)',
                                type: 'text'
                            },
                            {
                                id: 'feeder-line-loss-db-transmit',
                                header: 'Feeder Line Loss(dB) (Transmit)',
                                type: 'text'
                            },
                            {
                                id: 'feeder-line-loss-db-receive',
                                header: 'Feeder Line Loss(dB) (Receive)',
                                type: 'text'
                            },
                            {
                                id: 'bandwidth-khz-transmit',
                                header: 'Bandwidth (kHz) (Transmit)',
                                type: 'text'
                            },
                            {
                                id: 'bandwidth-khz-receive',
                                header: 'Bandwidth (kHz) (Receive)',
                                type: 'text'
                            },
                            {
                                id: 'emission-class-transmit',
                                header: 'Emission Class (Transmit)',
                                type: 'text'
                            }
                        ]
                    },
                    {
                        id: 'frequency-and-emission-class-info-accordion',
                        label: '',
                        type: 'accordion',
                        subFields: []
                    }
                ]
            }
        ],
        rule: {
            baseIds: [`${STATION_TYPE}-station-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const result = Boolean(baseValues && baseValues[`${STATION_TYPE}-station-type`] === 'Mobile/Portable Station');
                return result;
            }
        }
    },
    {
        sectionID: FILTER_INFORMATION,
        sectionName: 'Filter Information',
        fieldList: [
            {
                id: 'filter-information',
                label: '',
                type: 'tableAccordion',
                span: 12,
                subFields: [
                    {
                        id: 'filter-information-table',
                        label: '',
                        type: 'table',
                        subFields: [
                            {
                                id: 'no',
                                header: 'No.',
                                type: 'text'
                            },
                            {
                                id: 'manufacturer',
                                header: 'Manufacturer',
                                type: 'text'
                            },
                            {
                                id: 'model',
                                header: 'Model',
                                type: 'text'
                            },
                            {
                                id: 'insertion-loss-db',
                                header: 'Insertion Loss (dB)',
                                type: 'text'
                            },
                            {
                                id: 'tuned-frequency-mhz',
                                header: 'Tuned Frequency (MHz)',
                                type: 'text'
                            }
                        ]
                    },
                    {
                        id: 'filter-information-accordion',
                        label: '',
                        type: 'accordion',
                        subFields: []
                    }
                ]
            }
        ],
        rule: {
            baseIds: [`${STATION_TYPE}-station-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const result = Boolean(baseValues && baseValues[`${STATION_TYPE}-station-type`] !== 'Land Fixed Station');
                return result;
            }
        }
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
